import React from 'react';

const HideItemsOffCanvasIcon = ({
  width = 24,
  height = 24,
  color = '#000',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.58579 4L4 5.58579V18.4142L5.58579 20H18.4142L20 18.4142V5.58579L18.4142 4H5.58579ZM18 6L6 6V18H18V6Z"
      fill={color}
    />
  </svg>
);

export default HideItemsOffCanvasIcon;
